import script from "./OrderType.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderType.vue?vue&type=script&setup=true&lang=js"

import "./OrderType.vue?vue&type=style&index=0&id=1929138e&scoped=true&lang=less"

import exportComponent from "/data/web/pay/brpay/brpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1929138e"]])

export default __exports__